module.exports = __webpack_public_path__ + "img/1界面展示.ecbc4e61.png";